export const IFRAME_SYNCED_PREFIX = '@@iframe-synced/';

// Layout actions
export const CLONE_ELEMENT = `${IFRAME_SYNCED_PREFIX}CLONE_ELEMENT`;
export const REMOVE_ELEMENT = `${IFRAME_SYNCED_PREFIX}REMOVE_ELEMENT`;
export const DROP_NEW_ELEMENT_ON_ELEMENT = `${IFRAME_SYNCED_PREFIX}DROP_NEW_ELEMENT_ON_ELEMENT`;
export const DROP_NEW_ELEMENT_ON_SECTION = `${IFRAME_SYNCED_PREFIX}DROP_NEW_ELEMENT_ON_SECTION`;
export const DROP_NEW_ELEMENT_ON_PLACEHOLDER = `${IFRAME_SYNCED_PREFIX}DROP_NEW_ELEMENT_ON_PLACEHOLDER`;
export const APPEND_NEW_ELEMENT_TO_LAST_SECTION = `${IFRAME_SYNCED_PREFIX}APPEND_NEW_ELEMENT_TO_LAST_SECTION`;
export const UPDATE_ELEMENT_DATA = `${IFRAME_SYNCED_PREFIX}UPDATE_ELEMENT_DATA`;
export const UPDATE_ELEMENT_BREAKPOINT_STYLES = `${IFRAME_SYNCED_PREFIX}UPDATE_ELEMENT_BREAKPOINT_STYLES`;
export const UPDATE_MULTIPLE_FIELDS_ON_ELEMENT = `${IFRAME_SYNCED_PREFIX}UPDATE_MULTIPLE_FIELDS_ON_ELEMENT`;
export const CLONE_SECTION = `${IFRAME_SYNCED_PREFIX}CLONE_SECTION`;
export const REMOVE_SECTION = `${IFRAME_SYNCED_PREFIX}REMOVE_SECTION`;
export const UPDATE_SECTION_STYLE = `${IFRAME_SYNCED_PREFIX}UPDATE_SECTION_STYLE`;
export const UPDATE_SECTION_BREAKPOINT_STYLE = `${IFRAME_SYNCED_PREFIX}UPDATE_SECTION_BREAKPOINT_STYLE`;
export const CHANGE_SECTION_LAYOUT = `${IFRAME_SYNCED_PREFIX}CHANGE_SECTION_LAYOUT`;
export const DROP_ELEMENT_ON_SECTION = `${IFRAME_SYNCED_PREFIX}DROP_ELEMENT_ON_SECTION`;
export const DROP_ELEMENT_ON_ELEMENT = `${IFRAME_SYNCED_PREFIX}DROP_ELEMENT_ON_ELEMENT`;
export const UPDATE_FIELD_PATH = `${IFRAME_SYNCED_PREFIX}UPDATE_FIELD_PATH`;
export const DROP_ELEMENT_ON_PLACEHOLDER = `${IFRAME_SYNCED_PREFIX}DROP_ELEMENT_ON_PLACEHOLDER`;
export const DROP_SECTION_ON_SECTION = `${IFRAME_SYNCED_PREFIX}DROP_SECTION_ON_SECTION`;
export const DROP_LAYOUT_ON_SECTION = `${IFRAME_SYNCED_PREFIX}DROP_LAYOUT_ON_SECTION`;
export const DROP_SAVED_SECTION_ON_SECTION = `${IFRAME_SYNCED_PREFIX}DROP_SAVED_SECTION_ON_SECTION`;
export const SELECT_IS_SINGLE_COLUMN_FULL_WIDTH = `${IFRAME_SYNCED_PREFIX}SELECT_IS_SINGLE_COLUMN_FULL_WIDTH`;
export const REPLACE_ELEMENT = `${IFRAME_SYNCED_PREFIX}REPLACE_ELEMENT`;
export const SELECT_ELEMENT = `${IFRAME_SYNCED_PREFIX}SELECT_ELEMENT`;
export const SELECT_SECTION = `${IFRAME_SYNCED_PREFIX}SELECT_SECTION`;
export const SELECT_BUILTIN_WIDGET = `${IFRAME_SYNCED_PREFIX}SELECT_BUILTIN_WIDGET`;
export const REMOVE_CURRENT_SELECTED_ITEM = `${IFRAME_SYNCED_PREFIX}REMOVE_CURRENT_SELECTED_ITEM`;
export const ELEMENT_HIGHLIGHT = `${IFRAME_SYNCED_PREFIX}ELEMENT_HIGHLIGHT`;
export const FORCE_ELEMENT_HIGHLIGHT = `${IFRAME_SYNCED_PREFIX}FORCE_ELEMENT_HIGHLIGHT`;
export const CLICK_CATCHER_CLICKED = `${IFRAME_SYNCED_PREFIX}CLICK_CATCHER_CLICKED`;
export const ADD_NEW_COLUMN = `${IFRAME_SYNCED_PREFIX}ADD_NEW_COLUMN`;
export const ADD_NEW_COLUMN_AND_ELEMENT = `${IFRAME_SYNCED_PREFIX}ADD_NEW_COLUMN_AND_ELEMENT`;
export const REMOVE_COLUMN = `${IFRAME_SYNCED_PREFIX}REMOVE_COLUMN`;
export const INSERT_AI_DISCLAIMER_TEXT = `${IFRAME_SYNCED_PREFIX}INSERT_AI_DISCLAIMER_TEXT`;

// Layout settings
export const UPDATE_BOXED = `${IFRAME_SYNCED_PREFIX}UPDATE_BOXED`;
export const UPDATE_FIRST_INDEX_BOXED = `${IFRAME_SYNCED_PREFIX}UPDATE_FIRST_INDEX_BOXED`;
export const UPDATE_LAST_INDEX_BOXED = `${IFRAME_SYNCED_PREFIX}UPDATE_LAST_INDEX_BOXED`;
export const UPDATE_TEMPLATE_SETTING = `${IFRAME_SYNCED_PREFIX}UPDATE_TEMPLATE_SETTING`;
export const UPDATE_LINKS_FONT_STYLE = `${IFRAME_SYNCED_PREFIX}UPDATE_LINKS_FONT_STYLE`;
export const UPDATE_LAYOUT_PADDING = `${IFRAME_SYNCED_PREFIX}UPDATE_LAYOUT_PADDING`;
export const UPDATE_MOBILE_LAYOUT_PADDING = `${IFRAME_SYNCED_PREFIX}UPDATE_MOBILE_LAYOUT_PADDING`;
export const INHERIT_DEFAULT_STYLE_SETTINGS = `${IFRAME_SYNCED_PREFIX}INHERIT_DEFAULT_STYLE_SETTINGS`;

// Module defaults
export const BUTTON_DEFAULT_BACKGROUND_COLOR_CHANGE = `${IFRAME_SYNCED_PREFIX}BUTTON_DEFAULT_BACKGROUND_COLOR_CHANGE`;
export const BUTTON_DEFAULT_CORNER_RADIUS_CHANGE = `${IFRAME_SYNCED_PREFIX}BUTTON_DEFAULT_CORNER_RADIUS_CHANGE`;
export const BUTTON_DEFAULT_FONT_CHANGE = `${IFRAME_SYNCED_PREFIX}BUTTON_DEFAULT_FONT_CHANGE`;
export const DIVIDER_DEFAULT_HEIGHT_CHANGE = `${IFRAME_SYNCED_PREFIX}DIVIDER_DEFAULT_HEIGHT_CHANGE`;
export const DIVIDER_DEFAULT_COLOR_CHANGE = `${IFRAME_SYNCED_PREFIX}DIVIDER_DEFAULT_COLOR_CHANGE`;
export const DIVIDER_DEFAULT_LINE_TYPE_CHANGE = `${IFRAME_SYNCED_PREFIX}DIVIDER_DEFAULT_LINE_TYPE_CHANGE`;
export const FONT_DEFAULT_CHANGE = `${IFRAME_SYNCED_PREFIX}FONT_DEFAULT_CHANGE`;
export const CREATE_MANDATORY_FOOTER = `${IFRAME_SYNCED_PREFIX}CREATE_MANDATORY_FOOTER`;
export const UPDATE_SELECTED_SMART_RULE = `${IFRAME_SYNCED_PREFIX}UPDATE_SELECTED_SMART_RULE`;
export const DELETE_SMART_RULE = `${IFRAME_SYNCED_PREFIX}DELETE_SMART_RULE`;
export const RESIZE_COLUMNS = `${IFRAME_SYNCED_PREFIX}RESIZE_COLUMNS`;

// Rendering
export const HYDRATE_RENDERED_MODULES = `${IFRAME_SYNCED_PREFIX}HYDRATE_RENDERED_MODULES`;
export const UPDATE_RENDERED_MODULE = `${IFRAME_SYNCED_PREFIX}UPDATE_RENDERED_MODULE`;
export const UPDATE_RENDERED_IMAGE = `${IFRAME_SYNCED_PREFIX}UPDATE_RENDERED_IMAGE`;
export const UPDATE_RENDERED_CTA = `${IFRAME_SYNCED_PREFIX}UPDATE_RENDERED_CTA`;
export const UPDATE_RENDERED_RICH_TEXT = `${IFRAME_SYNCED_PREFIX}UPDATE_RENDERED_RICH_TEXT`;
export const START_MODULE_RENDER = `${IFRAME_SYNCED_PREFIX}START_MODULE_RENDER`;
export const INITIAL_MODULES_RENDERED = `${IFRAME_SYNCED_PREFIX}INITIAL_MODULES_RENDERED`;
export const REPOSITION_HUBSPOT_BRANDING_SECTION = `${IFRAME_SYNCED_PREFIX}REPOSITION_HUBSPOT_BRANDING_SECTION`;

// Onboarding actions
export const SHOW_EMAIL_ONBOARDING_DISMISS = `${IFRAME_SYNCED_PREFIX}SHOW_EMAIL_ONBOARDING_DISMISS`;
export const DISMISS_EMAIL_ONBOARDING = `${IFRAME_SYNCED_PREFIX}DISMISS_EMAIL_ONBOARDING`;
export const PREVIOUS_EMAIL_ONBOARDING_STEP = `${IFRAME_SYNCED_PREFIX}PREVIOUS_EMAIL_ONBOARDING_STEP`;
export const SKIP_EMAIL_ONBOARDING_STEP = `${IFRAME_SYNCED_PREFIX}SKIP_EMAIL_ONBOARDING_STEP`;

// Custom editor onboarding actions
export const RESET_ONBOARDING = `${IFRAME_SYNCED_PREFIX}/RESET_ONBOARDING`;
export const START_SINGLE_EMAIL_ONBOARDING = `${IFRAME_SYNCED_PREFIX}/START_SINGLE_EMAIL_ONBOARDING`;

// TODO move out from this file once syncing ungated
export const CREATE_WEBVERSION_LINK = `${IFRAME_SYNCED_PREFIX}CREATE_WEBVERSION_LINK`;
export const FETCH_ECOMM_SOURCES_STARTED = `${IFRAME_SYNCED_PREFIX}FETCH_ECOMM_SOURCES_STARTED`;
export const FETCH_ECOMM_SOURCES_SUCCEEDED = `${IFRAME_SYNCED_PREFIX}FETCH_ECOMM_SOURCES_SUCCEEDED`;
export const FETCH_ECOMM_SOURCES_FAILED = `${IFRAME_SYNCED_PREFIX}FETCH_ECOMM_SOURCES_FAILED`;
export const FETCH_CURRENCY_INFORMATION_STARTED = `${IFRAME_SYNCED_PREFIX}FETCH_CURRENCY_INFORMATION_STARTED`;
export const FETCH_CURRENCY_INFORMATION_SUCCEEDED = `${IFRAME_SYNCED_PREFIX}FETCH_CURRENCY_INFORMATION_SUCCEEDED`;
export const FETCH_CURRENCY_INFORMATION_FAILED = `${IFRAME_SYNCED_PREFIX}FETCH_CURRENCY_INFORMATION_FAILED`;
export const FETCH_SHOPIFY_STORES_STARTED = `${IFRAME_SYNCED_PREFIX}FETCH_SHOPIFY_STORES_STARTED`;
export const FETCH_SHOPIFY_STORES_SUCCEEDED = `${IFRAME_SYNCED_PREFIX}FETCH_SHOPIFY_STORES_SUCCEEDED`;
export const FETCH_SHOPIFY_STORES_FAILED = `${IFRAME_SYNCED_PREFIX}FETCH_SHOPIFY_STORES_FAILED`;

// sidebar
export const SELECT_PATTERN_EDIT = `${IFRAME_SYNCED_PREFIX}SELECT_PATTERN_EDIT`;
export const SET_MODULES_SEARCH_TERM = `${IFRAME_SYNCED_PREFIX}SET_MODULES_SEARCH_TERM`;
export const UPDATE_SIDEBAR_TAB = `${IFRAME_SYNCED_PREFIX}UPDATE_SIDEBAR_TAB`;
export const UPDATE_DEFAULT_TAB = `${IFRAME_SYNCED_PREFIX}UPDATE_DEFAULT_TAB`;
export const CLOSE_EMAIL_SIDEBAR = `${IFRAME_SYNCED_PREFIX}CLOSE_EMAIL_SIDEBAR`;
export const ADD_PANEL_TAB_CHANGED = `${IFRAME_SYNCED_PREFIX}ADD_PANEL_TAB_CHANGED`;
export const UPDATE_EDIT_SIDEBAR_ACTIVE_TAB = `${IFRAME_SYNCED_PREFIX}UPDATE_EDIT_SIDEBAR_ACTIVE_TAB`;